import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useDashboardsStore = defineStore('dashboards', {
  state: () => ({
    //
  }),
  getters: {},
  actions: {
    async getAssets(params = {}) {
      try {
        const response = await axios.get('dashboard/assets', {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async getDevices(params = {}) {
      try {
          const response = await axios.get('dashboard/devices', {params} );
          return response.data;
      } catch (error) {
          console.error(error.response);
          throw error.response;
      }
    },
    async getManufacturerDevices(params = {}) {
      try {
        const response = await axios.get('dashboard/manufacturers', {params} );
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
